import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classNames from 'classnames';
import { CardBlock } from '@sbt-web/ancillary-services';
import { useViewport } from '@sbt-web/hooks';
import type { AdItem } from '@sbt-web/network/types';
import { prepareRemoteDataAdDetail } from '@/shared/helpers/Hebe';
import { isPro } from '@/shared/models/Advertiser';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import { useAdvToggle } from '@/client/hooks/useAdvToggle';
import { useAncillaryServicesStatus } from '@/client/hooks/useAncillaryServicesStatus';
import { ReplacePhoneNumberWithButton } from './components/ReplacePhoneNumberWithPhoneButton';
import { getCopy } from './copy';
import classes from './AdDescription.module.scss';
interface Props {
  ad: AdItem;
}
const AdDescription: FC<Props> = t0 => {
  const $ = _c(24);
  const {
    ad
  } = t0;
  const {
    isMobile
  } = useViewport();
  const {
    body
  } = ad;
  const {
    noAdvToggle,
    optimizelyReady
  } = useAdvToggle();
  const ancillaryServicesEnabled = useAncillaryServicesStatus(ad);
  if (!body) {
    return null;
  }
  let t1;
  if ($[0] !== ad.advertiser.type) {
    t1 = isPro(ad.advertiser.type);
    $[0] = ad.advertiser.type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isProAdvertiser = t1;
  let t2;
  if ($[2] !== ad || $[3] !== body || $[4] !== isProAdvertiser) {
    t2 = isProAdvertiser ? <ReplacePhoneNumberWithButton ad={ad} /> : body;
    $[2] = ad;
    $[3] = body;
    $[4] = isProAdvertiser;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const bodyTextComponents = t2;
  let t3;
  if ($[6] !== ad) {
    t3 = getCopy(ad);
    $[6] = ad;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const copy = t3;
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className={classNames("headline-6", classes["description-title"])}>Descrizione</h2>;
    t5 = classNames("body-text", "book", classes.description);
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== bodyTextComponents) {
    t6 = <p className={t5}>{bodyTextComponents}</p>;
    $[10] = bodyTextComponents;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== copy) {
    t7 = copy != null ? <p className={classNames("body-text", "book", "small", classes.copy)}>{copy}</p> : null;
    $[12] = copy;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== ad || $[15] !== ancillaryServicesEnabled || $[16] !== isMobile || $[17] !== noAdvToggle || $[18] !== optimizelyReady) {
    t8 = optimizelyReady && noAdvToggle !== "B" && ancillaryServicesEnabled && <CardBlock padding={true} pulseInstance={getOrCreatePulse()} background={true} bannerButtonDesign="outline" item={ad} remoteData={prepareRemoteDataAdDetail("BELOW_DESCRIPTION", ad, isMobile)} classes={[classes["card-block-container"]]} />;
    $[14] = ad;
    $[15] = ancillaryServicesEnabled;
    $[16] = isMobile;
    $[17] = noAdvToggle;
    $[18] = optimizelyReady;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <>{t4}{t6}{t7}{t8}</>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
export default AdDescription;